// Copyright (c) 2017 PlanGrid, Inc.

import React from 'react';
import PropTypes from 'prop-types';

const UnsupportedViewer = props => (
  <div className="w-100 h-100 m-auto">
    <div className="m-auto text-center">
      {props.unsupportedComponent
        ? <props.unsupportedComponent {...props} />
        : <p className="alert"><b>{`.${props.fileType}`}</b> is not supported.</p>}
    </div>
  </div>
);

UnsupportedViewer.propTypes = {
  fileType: PropTypes.string.isRequired,
  unsupportedComponent: PropTypes.func.isRequired,
};

export default UnsupportedViewer;



// WEBPACK FOOTER //
// ./src/components/FileViewer/drivers/unsupported-viewer.jsx